import { render, staticRenderFns } from "./AlertOctagon.vue?vue&type=template&id=0218528c&scoped=true&"
import script from "./AlertOctagon.vue?vue&type=script&lang=js&"
export * from "./AlertOctagon.vue?vue&type=script&lang=js&"
import style0 from "./AlertOctagon.vue?vue&type=style&index=0&id=0218528c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218528c",
  null
  
)

export default component.exports